/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/MDBox";
import SoftTypography from "components/MDTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Grid, TextField, Stack, MenuItem, FormControl, InputLabel } from "@mui/material";
import Select from "react-select";
import MDButton from "components/MDButton";
import StagingController from "Controller/StagingController";
import MDInput from "components/MDInput";

function Staging() {
  const {
    PONumber,
    PODate,
    totalQuantity,
    error,
    selectedStageGroup,
    stageGroupOptions,
    stages,
    handleStageGroupChange,
    handleQuantityChange,
    handleRemarkChange,
    handleSubmit,vendorVertical,
  } = StagingController();

  const normalizedVendorVertical = (vendorVertical || "").toLowerCase();
  const quantityUnit =
    normalizedVendorVertical === "fabric" ? "mtr" : normalizedVendorVertical === "zcode" ? "pcs" : "";

  const customStyles = {
    option: (provided) => ({
      ...provided,
      zIndex: 999, // Adjust the value as needed
      fontSize: "0.9rem",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000, // Make sure this value is higher than the table header's z-index
      fontSize: "0.9rem",
    }),
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {cloading && <NewLoader></NewLoader>} */}
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card sx={{ padding: "10px", textAlign: "center" }}>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <SoftTypography variant="span" fontWeight="medium" mb={2}>
                  PO Number: {PONumber}
                </SoftTypography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <SoftTypography variant="span" fontWeight="medium" mb={2}>
                  PO Date: {PODate}
                </SoftTypography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <SoftTypography variant="span" fontWeight="medium" mb={2}>
                  Total PO Quantity {quantityUnit ? `(${quantityUnit})` : ""}: {totalQuantity} 
                </SoftTypography>
              </Grid>
            </Grid>
          </Card>
        </SoftBox>

        <SoftBox
          mb={2}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Select
            name="stageGroupValue"
            id="dropdown"
            placeholder="Select Stage Group"
            isSearchable={true}
            options={stageGroupOptions}
            value={selectedStageGroup}
            onChange={handleStageGroupChange}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // ensure dropdown is above everything
                backgroundColor: "white", // make background visible
              }),
              menuPortal: (provided) => ({ ...provided, zIndex: 9999 }), // if using portal
              container: (provided) => ({ ...provided, minWidth: "300px" }),
            }}
            menuPortalTarget={document.body}
          />
        </SoftBox>

        <Grid container mb={3} spacing={1}>
          {stages &&
            Object.entries(stages).map(([stage, details], index) => (
              <Grid key={index} item xs={12} sm={4}>
                <Card sx={{ marginBottom: "10px" }}>
                  <SoftBox pt={2} px={2} mb={3} alignItems="center">
                    <SoftTypography variant="h6" fontWeight="medium" mb={2}>
                      {details.stage_status_name}
                    </SoftTypography>
                    <Grid item xs={12}>
                      <Stack spacing={2}>
                        <MDInput
                          fullWidth
                          id={`fresh-quantity-${index}`}
                          label="Fresh quantity"
                          variant="outlined"
                          defaultValue={details.fresh_qty} // API data के हिसाब से
                          onChange={(e) => handleQuantityChange(index, e.target.value)}
                          // error={Boolean(error[index])}
                          // helperText={error[index] || ""}
                          FormHelperTextProps={{ sx: { color: "error.main" } }}
                          disabled={stages[index].isFromAPI}
                        />
                        <TextField
                          id={`remark-${index}`}
                          label="Remark"
                          multiline
                          rows={3}
                          fullWidth
                          defaultValue={details.remark}
                          onChange={(e) => handleRemarkChange(stage, e.target.value)}
                        />
                      </Stack>
                    </Grid>
                  </SoftBox>
                </Card>
              </Grid>
            ))}
        </Grid>

        <SoftBox textAlign="center" mt={2}>
          <MDButton variant="gradient" color={"error"} onClick={handleSubmit}>
            Submit
          </MDButton>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

export default Staging;
